import { apiGet, apiPost } from '@/api/axios-client'

/** What an approver is handed: the same shape the API stores, with the files as attachments. */
export interface PackFile {
  id: string
  key: string
  name: string
  contentType: string
  size: number
}

export interface ReviewPack {
  id: string
  cardId: string
  submittedBy: string
  submittedAt: string
  /** One of these three carries the documentation. */
  document: PackFile | null
  documentLink: string | null
  writeUp: string | null
  photo: PackFile
  link: string
  bullets: string[]
}

export interface ReviewPackResponse {
  pack: ReviewPack | null
  previous: number
  submitter: { id: string; displayName: string; photoUrl: string | null } | null
}

export interface ReviewPackInput {
  document?: { key: string; name: string }
  documentLink?: string
  writeUp?: string
  photo: { key: string; name: string }
  link: string
  bullets: string[]
}

export const reviewPackApi = {
  get: (cardId: string) => apiGet<ReviewPackResponse>(`review-packs/card/${cardId}`),
  create: (cardId: string, body: ReviewPackInput) =>
    apiPost<{ pack: ReviewPack }>(`review-packs/card/${cardId}`, body),
}

export const reviewPackKey = (cardId: string) => ['review-pack', cardId] as const
